module.exports = __webpack_public_path__ + "img/b9f535f.webp";